/* IV Biotics product media gallery — mobile swipe carousel + thumbnails + dots.
   On desktop the gallery is a vertical stack and this script is effectively a
   no-op (thumbnails/dots are hidden and the track does not scroll horizontally). */
(function () {
  function init(media) {
    if (media.dataset.galleryInit === '1') return;
    const gallery = media.querySelector('.ivb-product__gallery');
    if (!gallery) return;
    const cards = Array.prototype.slice.call(gallery.querySelectorAll('.ivb-product__media-card'));
    if (cards.length < 2) return;
    const thumbs = Array.prototype.slice.call(media.querySelectorAll('.ivb-product__thumb'));
    const dots = Array.prototype.slice.call(media.querySelectorAll('.ivb-product__dot'));
    media.dataset.galleryInit = '1';

    function setActive(i) {
      thumbs.forEach(function (t, idx) {
        const on = idx === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === i);
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        cards[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        setActive(i);
      });
    });

    let raf = null;
    gallery.addEventListener(
      'scroll',
      function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          const g = gallery.getBoundingClientRect();
          const center = g.left + g.width / 2;
          let best = 0;
          let dist = Infinity;
          cards.forEach(function (c, i) {
            const r = c.getBoundingClientRect();
            const d = Math.abs(r.left + r.width / 2 - center);
            if (d < dist) {
              dist = d;
              best = i;
            }
          });
          setActive(best);
        });
      },
      { passive: true }
    );

    setActive(0);
  }

  function initAll(root) {
    (root || document).querySelectorAll('.ivb-product__media').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
